<template>
    <div class="flex flex-col w-full">
        <div class="flex items-center mb-1">
            <div class="mr-4">
                <label v-if="label" :for="id" class="font-bold">{{ label }}</label>
            </div>
            <div>
                <span v-if="error" class="mt-1 text-xs text-italic mt-1 text-red-500">
                    {{ error }}
                </span>
            </div>
        </div>
        <textarea :id="id" v-model="inputValue" :name="name"></textarea>
    </div>
</template>

<script>
const lazyTinymce = () => import(/* webpackChunkName: "lazy-loaded/tinymce" */ 'tinymce/tinymce');
import uniqueId from 'lodash/uniqueId';

export default {
    props: {
        id: {
            type: String,
            default: () => {
                return uniqueId('my_editor_');
            }
        },
        name: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: 'Text Input'
        },
        value: {
            type: String,
            default: null
        },
        error: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            inputValue: this.value,
            editor: null,
            tinymceAssetsPath: '/tinymce'
        };
    },

    watch: {
        value: function(val, preVal) {
            if (this.inputValue !== val && val !== preVal) {
                this.inputValue = val;

                this.editor.activeEditor.setContent(val);
            }
        }
    },

    mounted() {
        this.initEditor();
    },

    beforeDestroy() {
        this.destroyEditor();
    },

    methods: {
        initEditor() {
            lazyTinymce().then(({ default: tinymce }) => {
                this.editor = tinymce;
                this.editor.baseURL = this.tinymceAssetsPath;

                this.editor.init({
                    selector: '#' + this.id,
                    menubar: false,
                    plugins: 'link lists paste hr',
                    paste_as_text: true,
                    content_style: 'h3 { margin: 0px; margin-bottom: 19px; } p { margin: 0; margin-bottom: 15px; }',
                    toolbar: 'bold italic h3 | link numlist bullist hr | undo redo |',
                    setup: ed => {
                        ed.on('change keyup undo redo', () => {
                            this.onEditorChange(ed);
                        });
                    }
                });
            });
        },

        destroyEditor() {
            this.editor.remove('#' + this.id);
        },

        onEditorChange(editor) {
            this.inputValue = editor.getContent();

            this.$emit('input', this.inputValue);
        }
    }
};
</script>
